import { render, staticRenderFns } from "./HistorialApi.vue?vue&type=template&id=aff90b94&scoped=true&"
import script from "./HistorialApi.vue?vue&type=script&lang=js&"
export * from "./HistorialApi.vue?vue&type=script&lang=js&"
import style0 from "./HistorialApi.vue?vue&type=style&index=0&id=aff90b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff90b94",
  null
  
)

export default component.exports